import { Helmet } from 'react-helmet';

// Support page (9/2) — Josh: no copy. Two links, nothing else. Each fires
// shop_click with its own `destination` so GA can tell them apart.
const OPTIONS = [
  { id: 'etsy', emoji: '\u{1F516}', label: 'FlickMarks on Etsy', href: 'https://www.etsy.com/listing/1791662027/movie-bookmark-gift-for-movie-lover' },
  { id: 'coffee', emoji: '\u2615', label: 'Buy us a coffee', href: 'https://buymeacoffee.com/filmrevivalnyc' },
];

export default function Support() {
  return (
    <div style={{ maxWidth: '520px', margin: '0 auto', padding: '0 20px 60px' }}>
      <Helmet>
        <title>Support Film Revival NYC</title>
        <meta name="description" content="Support Film Revival NYC: shop FlickMarks 35mm bookmarks or buy us a coffee." />
        <link rel="canonical" href="https://filmrevivalnyc.com/support" />
      </Helmet>

      <h1 style={{ fontFamily: "'Cinzel', Georgia, serif", fontSize: '1.8rem', letterSpacing: '2px', margin: '0 0 24px', textAlign: 'center' }}>
        Support the Site
      </h1>

      <div style={{ display: 'grid', gap: '14px' }}>
        {OPTIONS.map((o) => (
          <a
            key={o.id}
            href={o.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => window.gtag && window.gtag('event', 'shop_click', {
              destination: o.id, location: 'support_page', transport_type: 'beacon',
            })}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
              border: '1px solid #d4cec4', borderRadius: '10px', background: '#faf7f2',
              padding: '20px', textDecoration: 'none', color: '#1a1714',
              fontFamily: "'Cinzel', Georgia, serif", fontSize: '1rem', letterSpacing: '0.5px',
            }}
          >
            <span style={{ fontSize: '1.2rem' }}>{o.emoji}</span>
            {o.label}
          </a>
        ))}
      </div>
    </div>
  );
}
